import React from 'react';

const SvgTwitch = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M1.7 0 .5 2.77v11.08h3.69V16h2.16l2.15-2.15h3.31L16.5 9.16V0H1.7Zm1.38 1.39h12v7.07l-2.46 2.46H8.5l-2.16 2.16v-2.16H3.08V1.39Zm3.23 2.3v4H7.7v-4H6.31Zm3.7 0v4h1.38v-4H10Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTwitch;
